/**
 * Created by sergeys on 12.04.2017.
 */
import { Injectable } from '@angular/core';
import { RequestTypes } from '../models/request-types.enum';
import { DictionaryNum } from '../models/dictionary';

@Injectable()
export class HttpConfiguration {
    public Servers: DictionaryNum<string>;

    constructor() {
        this.Servers = new DictionaryNum<string>();

        // Internal
        this.Servers[RequestTypes.InternalApi] = '/';
    }
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/configs/app.http.config.ts